import React from "react";
import "../../People.css";
import "../../assets/css/people.css";
import studentData from "../../data/students.json";

const Alumni = () => {
  return (
    <div className="people-container">
      {/* Alumni Section */}
      <div id="alumni" className="alumni-section">
        <h1 className="section-heading">Alumni</h1>
        <div className="alumni-grid">
          {studentData.alumni.map((alumnus, index) => (
            <div className="alumni-member" key={index}>
              <h3 className="team-name">{alumnus.name}</h3>
              <p className="team-designation">{alumnus.rollNo}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Alumni;
